import styled from 'styled-components';
import { FaUserCircle } from 'react-icons/fa';

const UserImage = styled.img`
  margin: auto;
  width: 12rem;
  height: 12rem;
  border-radius: 50%;
  border: 1px solid var(--border);
  cursor: pointer;
  align-self: center;
  object-fit: cover;
  transition: opacity var(--dur-fast) var(--ease-standard);

  :hover {
    opacity: 0.75;
  }
`;

const UserIcon = styled(FaUserCircle)`
  width: 12rem;
  height: 12rem;
  color: var(--border-strong);
  cursor: pointer;
  align-self: center;
  transition: color var(--dur-fast) var(--ease-standard);

  :hover {
    color: var(--ink-faint);
  }
`;

export { UserIcon, UserImage };
